/** ArticleTakeaways (G2, D9): section > h2 + ul (article list rules). The panel is the section's surfaceRole (PR5). */
import React, { memo } from 'react';
import { NEUTRAL_LIST } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/ArticleList';
import type { ArticleBlockProps } from '@modules/screen-view-v2/components/screens/FlexibleLayout/article/types';
import { slugifyHeading } from '@modules/screen-view-v2/utils/articleSlug';
import { resolveLocaleText } from '@modules/screen-view-v2/utils/articleText';

export const ArticleTakeaways = memo(function ArticleTakeaways({ section, locale, article }: ArticleBlockProps): React.ReactElement | null {
  const content = section.articleTakeawaysContent;
  const items = (content?.items ?? []).map((item) => resolveLocaleText(item, locale)).filter(Boolean);
  if (items.length === 0) return null;
  const heading = resolveLocaleText(content?.heading, locale);
  const headingId = `ap-${slugifyHeading(section.id)}-heading`;
  return (
    <section className="ap-block ap-takeaways" aria-labelledby={heading ? headingId : undefined}>
      {heading ? <h2 id={headingId} className="ap-panel-title">{heading}</h2> : null}
      <ul className="ap-list" data-article-list="" style={article.presentation ? undefined : NEUTRAL_LIST}>
        {items.map((item, index) => <li key={index}>{item}</li>)}
      </ul>
    </section>
  );
});

ArticleTakeaways.displayName = 'ArticleTakeaways';
